// Common
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { warmUpObservable } from '@frontendlib/common/decorators/warm-up-observable';

// RxJS
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

// Types
import type { FeedbackConfig } from '@frontendlib/common/types/FeedbackConfig';
import { Session } from '@modules/account/types/session';
import { BaseService } from '@modules/common/services/base.service';
import { BaseSearchResponse } from '@modules/common/types/base-search-response';

@Injectable()
export class SessionsService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  search(): Observable<BaseSearchResponse<Session>> {
    return this.refreshRequired.pipe(
      switchMap(() => this.http.get<{ items: object[]; count: number }>(environment.baseUrl + '/api/account/sessions')),
      map(({ items = [], count }) => ({
        items: items.map((item) => new Session(item)),
        count,
      })),
    );
  }

  @warmUpObservable
  destroySession(session) {
    return this.http
      .delete(environment.baseUrl + '/api/account/sessions/' + session.id)
      .pipe(tap(() => this.refreshRequired.next(0)));
  }

  @warmUpObservable
  destroyOtherSessions() {
    return this.http
      .delete(environment.baseUrl + '/api/account/sessions/logout-other-sessions')
      .pipe(tap(() => this.refreshRequired.next(0)));
  }

  create(_instance: Session, _feedbackConfig: FeedbackConfig): Observable<Session> {
    throw new Error('Method is not available');
  }
}
